import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { activites } from "../mock";

const Activite = () => {
  const navigate = useNavigate();
  return (
    <section id="activite" className="bg-[#F7F4EF] py-24 md:py-32" data-nav-theme="light">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <h2
          className="font-display uppercase text-neutral-900 leading-[0.95] mb-6"
          style={{ fontSize: "clamp(38px, 5vw, 84px)" }}
        >
          Notre activité
        </h2>
        <p className="text-neutral-600 text-[15px] leading-relaxed max-w-xl">
          Construction sur mesure, programmes immobiliers et rénovation tous
          corps d'état : nous couvrons l'ensemble de vos projets, du terrain
          à la remise des clés.
        </p>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {activites.map((a) => (
            <article
              key={a.id}
              className="group relative overflow-hidden bg-neutral-100 aspect-[4/5] cursor-pointer transition-all duration-500 hover:shadow-2xl active:scale-[0.985]"
              onClick={() => navigate(`/activite/${a.id}`)}
            >
              <img
                src={a.image}
                alt={a.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-transparent transition-opacity duration-500 group-hover:from-black/95" />
              <div className="absolute inset-x-0 bottom-0 p-7 md:p-9 text-white transition-transform duration-500 group-hover:-translate-y-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="font-display text-xl">{a.num}</span>
                  <span className="h-px w-8 bg-[#9F8B76] transition-all duration-500 group-hover:w-16" />
                </div>
                <h3
                  className="font-display uppercase leading-none"
                  style={{ fontSize: "clamp(26px, 2.8vw, 40px)" }}
                >
                  {a.title}
                </h3>
                <p className="mt-2 text-white/80 italic text-sm">{a.subtitle}</p>
                <p className="mt-4 text-white/85 text-[14px] leading-relaxed max-w-md">
                  {a.text}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-white text-[11px] uppercase tracking-widest group-hover:text-[#9F8B76] transition-colors">
                  Découvrir
                  <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Activite;
